<div class="tree-item leaf">
	<div class="tree-item-value">
		<table class="leaf">
			<tr class="nodeHeader">
				<td class="nodeName">
					<span>{{ box.name }}</span>
				</td>
				<td class="nodeAction">
					<mat-icon id="menuIcon" class="menu-icon" (click)="displayContextualMenu($event, box); $event.preventDefault()">more_vert</mat-icon>
				</td>
			</tr>
			<tr>
				<td class="nodeInfo" colspan="2">
					@if (isIdVisible === true) {
						<span>id&nbsp;:&nbsp;{{ box.id }}</span>
					}
					<span>order&nbsp;:&nbsp;{{ box.order }}</span>
				</td>
			</tr>
		</table>
	</div>
</div>

<app-contextual-menu [items]="menuItems" (menuChanged)="onMenuChanged($event)"></app-contextual-menu>
